// extracted by mini-css-extract-plugin
export default {"content":"thankyou_content__vppIs"};